import React from 'react'
import { makeStyles } from '@mui/styles'

import lang from 'lang'
import CheckIcon from 'assets/images/icons/check.svg'
import { ModalBig } from '../../../../base/components/modal/index'
import { CancelButton, ButtonIconSquare } from '../../../../base/components/buttons/index'

export default function CancelBookingModal(props) {
  const { onSubmit, onAbort } = props
  const classes = useStyles()

  const actions = [
    <CancelButton
      type='cancel'
      label={lang.cancelButtonLabel}
      onClick={onAbort} />,
    <ButtonIconSquare
      type='submit'
      icon={CheckIcon}
      customClass={classes.submitButton}
      label={lang.confirmButtonLabel}
      onClick={onSubmit} />,
  ]

  return (
    <ModalBig
      disableEscapeKeyDown
      disableBackdropClick
      open={true}
      title={lang.bankBookingCancelModalTitle}
      actions={actions}
      onClose={onAbort}>
      <div className={classes.content}>
        <div>
          {lang.bankBookingCancelModalDescription}
        </div>
        <form className={classes.form} onSubmit={onSubmit} />
      </div>
    </ModalBig>
  )
}

const useStyles = makeStyles(() => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
  loader: {
    height: '100%',
  },
  titleWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  title: {
    padding: '0px 15px',
  },
  form: {
    padding: '0px 15px',
    marginBottom: 25,
  },
  submitButton: {
    marginLeft: 15,
  },
}))
